import { CssQuestionType } from '@webapp/common/components/survey-custom';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';

import { MatrixLayout } from '../matrix-layout';

import { MatrixTextGroup } from './group';

export const MatrixText: FC<SurveyQuestion> = ({ question }) => (
    <MatrixLayout cell={MatrixTextGroup} className={CssQuestionType.MATRIX_TEXT} question={question} />
);
MatrixText.displayName = 'MatrixAnswerText';
